export const UNDO_STACK_MAX_DEPTH = 7;
export const UNDO_TOAST_TIMEOUT_MS = 15000;

export const UNDO_REGISTER_COMMAND = "UNDO_REGISTER_COMMAND";
export const UNDO_MARK_UNDONE = "UNDO_MARK_UNDONE";
export const UNDO_MARK_TOAST_HIDDEN = "UNDO_MARK_TOAST_HIDDEN";
export const UNDO_UPDATE_TOAST_ID = "UNDO_UPDATE_TOAST_ID";
export const UNDO_REMOVE_COMMAND = "UNDO_REMOVE_COMMAND";
export const UNDO_CLEAR_SCOPE = "UNDO_CLEAR_SCOPE";
